import { render, staticRenderFns } from "./OrganizationPackages.vue?vue&type=template&id=4167f6bc&scoped=true"
import script from "./OrganizationPackages.vue?vue&type=script&lang=js"
export * from "./OrganizationPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167f6bc",
  null
  
)

export default component.exports